import React from "react";
import { motion } from "framer-motion";

interface RevealAnimationProps {
  children: React.ReactNode;
  isRevealed: boolean;
}

const RevealAnimation: React.FC<RevealAnimationProps> = ({ children, isRevealed }) => {
  return (
    <motion.div
      className="relative"
      initial={false}
      animate={isRevealed ? "revealed" : "hidden"}
    >
      {children}
      {isRevealed && (
        <motion.div
          className="absolute inset-0 pointer-events-none"
          initial={{ x: "-100%", opacity: 0 }}
          animate={{ x: "100%", opacity: 0 }}
          transition={{
            duration: 1,
            ease: "easeInOut",
          }}
          style={{
            background: "linear-gradient(90deg, transparent, rgba(147, 51, 234, 0.1), rgba(236, 72, 153, 0.2), rgba(147, 51, 234, 0.1), transparent)",
            boxShadow: "0 0 20px rgba(147, 51, 234, 0.2)",
          }}
        />
      )}
    </motion.div>
  );
};

export default RevealAnimation; 